<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    class?: string;
    padding?: 'none' | 'sm' | 'md' | 'lg';
}

const props = withDefaults(defineProps<Props>(), {
    padding: 'md',
});

const paddingClass = computed(() => {
    switch (props.padding) {
        case 'none':
            return '';
        case 'sm':
            return 'p-3';
        case 'lg':
            return 'p-6';
        case 'md':
        default:
            return 'p-5';
    }
});
</script>

<template>
    <!-- Card per design: surface + border + radius 12/16 + optional card shadow -->
    <div
        :class="[
            'bg-surface border-border rounded-xl border shadow-[var(--shadow-card)]',
            paddingClass,
            props.class,
        ]"
    >
        <slot />
    </div>
</template>
